import React, { useEffect } from 'react'
import { Tabs, Button } from 'antd';
import tractor1 from '../../images/tractor-1.jpg'
import tractor2 from '../../images/tractor-2.jpg'
import tractor3 from '../../images/tractor-3.jpg'
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import OtherTractorCard from './OtherTractorCard';


SwiperCore.use([Navigation]);

const swiperParams = {
    slidesPerView: 1.2,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 4.5,
        },
        600: {
            slidesPerView: 3.2,
        },
    },
}

const { TabPane } = Tabs;

const viewAll = <Button type="primary" >View All</Button>;


function OtherTractorSection({ type }) {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <div className="flex justify-between border-b">
                        <h2 className="text-2xl font-bold text-gray-700 px-2 pb-2">{type} Tractors</h2>
                        {viewAll}
                    </div>
                    
                    <Swiper
                        {...swiperParams}
                        navigation={true}
                        // onSlideChange={() => console.log('slide change')}
                        // onSwiper={(swiper) => console.log(swiper)}
                    >

                        <SwiperSlide key="1">
                            <OtherTractorCard imageUrl={tractor1} />
                        </SwiperSlide>

                        <SwiperSlide key="2">
                            <OtherTractorCard imageUrl={tractor2} />
                        </SwiperSlide>
                        
                        <SwiperSlide key="3">
                            <OtherTractorCard imageUrl={tractor3} />
                        </SwiperSlide>

                        <SwiperSlide key="4">
                            <OtherTractorCard imageUrl={tractor1} />
                        </SwiperSlide>

                        <SwiperSlide key="5">
                            <OtherTractorCard imageUrl={tractor2} />
                        </SwiperSlide>
                        
                        <SwiperSlide key="6">
                            <OtherTractorCard imageUrl={tractor3} />
                        </SwiperSlide>

                        <SwiperSlide key="7">
                            <OtherTractorCard imageUrl={tractor1} />
                        </SwiperSlide>

                        <SwiperSlide key="8">
                            <OtherTractorCard imageUrl={tractor2} />
                        </SwiperSlide>
                        
                        <SwiperSlide key="9">
                            <OtherTractorCard imageUrl={tractor3} />
                        </SwiperSlide>

                    </Swiper>
                    
                </div>
            </div>
            
        </div>
    );
}

export default OtherTractorSection;
